<template>
  <div
    :style="{
      background: config.style.question.color ? config.style.question.color + '!important' : false,
      width: config.style.question.width ? config.style.question.width + 'px !important' : false,
    }"
  >
    <h1 v-html="config.txt" :style="getStyle(config)"></h1>
    <div v-if="config.src !== undefined">
      <img
        v-for="(a, i) in config.src"
        :key="'config_' + i"
        :src="a"
        :style="{
          'padding-left': i > 0 ? config.style.question.dist + 'px' : false,
        }"
      />
    </div>
    <section>
      <div
        v-for="(a, i) in config.ans"
        :key="'answer_' + i"
        @click="selectAnswer(i)"
        :class="[{ good: isCorrect() == 1 }, { bad: isCorrect() == 2 }]"
        :style="{ width: config.w + 'px !important' }"
      >
        <input type="radio" :id="config.id + '-' + i" :name="config.id" :checked="checkSelect(i)" :value="i" />
        <label :for="config.id + '-' + i" :style="{ width: config.w + 'px !important' }">
          <span v-html="a"></span>
        </label>
      </div>
    </section>
  </div>
</template>

<script>
import _ from 'lodash';
import { getGamePath } from './../../../Utils/pathUtils.js';
export default {
  name: 'mp-question',
  components: {},
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  beforeMount() {},
  mounted() {},
  methods: {
    selectAnswer(i) {
      this.config.val = i;
      this.config.checks = false;
      this.resetCheckStatus();
    },
    checkSelect(i) {
      if (this.config.val == null) return false;
      return this.config.val == i;
    },
    isCorrect() {
      if (!this.config.checks || this.config.val === null) this.config.isCorrect = 0;
      else {
        if (this.config.val === this.config.correct) this.config.isCorrect = 1;
        else this.config.isCorrect = 2;
      }
      return this.config.isCorrect;
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      /** @type {Boolean}  return true becouse want to event to propagate  */
      return true;
    },
    getStyle(item) {
      // padding: 5%;
      // margin-top: 12%;
      return _.merge({}, this.getCustomStyle(item));
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  computed: {},
  watch: {},
};
</script>
<style lang="scss" scoped>
h1 {
  color: hsla(215, 5%, 10%, 1);
  margin-bottom: 2rem;
  text-align: center;
}

section {
  display: flex;
  flex-flow: row wrap;
}

section > div {
  flex: 1;
  padding: 0.5em;
}

input[type='radio'] {
  display: none;
  &:not(:disabled) ~ label {
    cursor: pointer;
  }
  &:disabled ~ label {
    color: hsla(150, 5%, 75%, 1);
    border-color: hsla(193, 5%, 75%, 1);
    box-shadow: none;
    cursor: not-allowed;
  }
}

label {
  height: 100%;
  display: inline-block;
  justify-content: center;
  align-items: center;
  background: white;
  border: 2px solid hsla(193, 75%, 50%, 1);
  border-radius: 20px;
  padding: 1.5rem 1rem 1rem;
  margin-bottom: 1rem;
  text-align: center;
  box-shadow: 0 3px 10px -2px hsla(193, 5%, 65%, 0.5);
  position: relative;
}

input[type='radio']:checked + label {
  background: hsla(193, 75%, 50%, 1);
  color: hsla(215, 0%, 100%, 1);
  box-shadow: 0 0 20px hsla(193, 100%, 50%, 0.75);
  &::after {
    color: hsla(215, 5%, 25%, 1);
    font-family: FontAwesome;
    border: 2px solid hsla(193, 75%, 45%, 1);
    content: '✔';
    font-size: 24px;
    position: absolute;
    top: -25px;
    left: 50%;
    transform: translateX(-50%);
    height: 50px;
    width: 50px;
    line-height: 50px;
    text-align: center;
    border-radius: 50%;
    background: white;
    box-shadow: 0 2px 5px -2px hsla(0, 0%, 0%, 0.25);
  }
}

span {
  font-weight: 900;
}

@media only screen and (max-width: 700px) {
  section {
    flex-direction: column;
  }
}

.good input[type='radio']:checked + label {
  background: hsla(150, 75%, 50%, 1);
  border-color: hsla(150, 75%, 50%, 1);
}

.bad input[type='radio']:checked + label {
  background: hsla(360, 75%, 50%, 1);
  border-color: hsla(360, 75%, 50%, 1);
}
</style>
